import CubmuLogo from "../../assets/images/cubmu.svg";

export function AddonsCubmuSection() {
  return (
    <div
      className="addons"
      style={{
        background: "#0a0a0a",
        color: "white",
      }}
    >
      <img src={CubmuLogo} alt="CubMu Logo" />
      <div>
        <p>
          Bayar tagihan Anda dan unduh aplikasi{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.viberlink.viberlink_user"
            target="__blank"
            className="text-white"
          >
            MyViberlink
          </a>{" "}
          untuk menikmati layanan CubMu secara GRATIS. CubMu adalah layanan
          dengan konten hiburan, edukasi, dan layanan digital lainnya.
        </p>
        {/* TODO Change link */}
        <a
          href="https://viberlink.net/"
          target="__blank"
          className="text-white"
        >
          Info lebih lanjut!
        </a>
      </div>
    </div>
  );
}
